import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; 

// 🟢 NEW IMPORT FOR ZOOM FEATURE
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import ReactDOM from 'react-dom';

import './App.css'; 

// --- IMPORTS ---
import LoginSignup from './LoginSignup';
import Checkout from './Checkout';
import Profile from './Profile';
import AdminPage from './AdminPage';
import ProfileSidebar from './ProfileSidebar';
import CreateAdmin from './CreateAdmin'; 
import ProductReview from './ProductReview';
import OrderConfirmation from './OrderConfirmation';

// IMPORT POLICY PAGES
import { 
    PrivacyPolicy, TermsConditions, AboutUs, ShippingPolicy, 
    ReturnExchange, RefundPolicy, OurStory, ContactUsPage 
} from './Policies';
// --- YEH SAB HELPER FUNCTIONS FILE MEIN UPAR IMPORT KE BAAD RAKHEIN ---

// 1. PRICE DISPLAY


// 2. SLUG GENERATOR
const generateSlug = (name) => {
    if (!name) return '';
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
};

// 3. SOLD OUT CHECKER


// 4. RAZORPAY SAFE IMAGE URL (THE FIX FOR YOUR ERROR)
// 4. RAZORPAY SAFE IMAGE URL (THE FIX FOR YOUR ERROR)
const getRazorpaySafeImageUrl = (rawImage) => {
    let img = rawImage || "";
    
    // Agar image array string format mein hai, toh pehli image nikalo
    if (img.startsWith("[")) {
        try { img = JSON.parse(img)[0]; } catch(e) { img = img.replace(/[\[\]"]/g, ''); }
    }
    
    // Agar image khali hai ya abhi bhi koi purani base64 hai
    if (!img || img.startsWith("data:image") || img.includes("localhost") || img.includes("127.0.0.1")) {
        return "https://antarvaani.com/favicon-512.png"; 
    }

    // MAIN UPLOADS FIX: Agar sirf image name hai, toh live server ka uploads folder jodo (/api/uploads/)
    if (!img.startsWith('http') && !img.startsWith('blob:')) {
        img = `https://antarvaani.com/api/uploads/${img.startsWith('/') ? img.substring(1) : img}`;
    }
    
    // HTTP ko HTTPS banayein
    img = img.replace("http://", "https://");

    // 🟢 THE FINAL MAGIC: Spaces ko %20 mein convert karna (Razorpay spaces wale URL reject karta hai)
    return encodeURI(img);
};

// 5. ORIGINAL IMAGE FOR CONFIRMATION PAGE
const getOriginalImageUrl = (rawImage) => {
    let img = rawImage || "/assets/placeholder.jpg";
    if (img.startsWith("[")) {
        try { img = JSON.parse(img)[0]; } catch(e) { img = img.replace(/[\[\]"]/g, ''); }
    }
    
    // 🟢 MAIN UPLOADS FIX: Website listings aur Order Summary ke liye (/api/uploads/)
    if (!img.startsWith('http') && !img.startsWith('data:image') && !img.startsWith('blob:') && !img.startsWith('/assets')) {
        img = `https://antarvaani.com/api/uploads/${img.startsWith('/') ? img.substring(1) : img}`;
    }
    return img;
};

// ==========================================
// 🟢 SPEED BOOSTER: GLOBAL CACHE
// ==========================================
let globalProductsCache = null;
let globalCarouselCache = null;


// --- HELPER: SCROLL TO TOP ---
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { 
        setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }, 50); 
    }, [pathname]);
    return null;
};

// COMPONENT: SPINNING LOADER
const Preloader = () => {
    return (
        <div className="loader-overlay">
            <img src="/loader-logo.png" alt="Loading..." className="loader-img" />
        </div>
    );
};

// --- COMPONENT: MARQUEE BAR ---
const MarqueeBar = () => {
    const singleText = "COD AVAILABLE  •  FREE SHIPPING  •  EXTRA 5% OFF ON PREPAID  • ";
    const superLongText = singleText.repeat(50); 

    return (
        <div style={{ 
            display: 'flex', 
            overflow: 'hidden', 
            whiteSpace: 'nowrap', 
            width: '100vw', 
            marginLeft: 'calc(50% - 50vw)', 
            backgroundColor: '#000', 
            padding: '6px 0',
            marginTop: '5px',
            marginBottom:'0px' 
        }}>
            <motion.div
                animate={{ x: ["0%", "-50%"] }}
                transition={{ repeat: Infinity, ease: "linear", duration: 100 }} 
                style={{ display: 'flex', whiteSpace: 'nowrap', width: 'max-content' }}
            >
                <span style={{ color: '#fff', fontSize: '0.8rem', fontWeight: 'bold', letterSpacing: '2px' }}>
                    {superLongText}
                </span>
            </motion.div>
        </div>
    );
};

// 🟢 PRICE DISPLAY HELPER
const PriceDisplay = ({ price, mrp }) => {
    const sellingPrice = parseFloat(price);
    const actualPrice = parseFloat(mrp);

    if (!isNaN(actualPrice) && actualPrice > sellingPrice) {
        return (
            <div style={{display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', marginTop:'5px'}}>
                <span style={{textDecoration: 'line-through', color: '#777', fontSize: '0.85rem'}}>Rs. {actualPrice}</span>
                <span className="price" style={{fontWeight: 'bold', fontSize:'1rem', color: 'black'}}>Rs. {sellingPrice}</span>
            </div>
        );
    }
    return <span className="price" style={{display:'block', marginTop:'5px', fontWeight: 'bold', fontSize:'1rem', color: 'black'}}>Rs. {sellingPrice}</span>;
};

const checkSoldOut = (stockStr) => {
    if (!stockStr) return false;
    try {
        const stockObj = typeof stockStr === 'string' ? JSON.parse(stockStr) : stockStr;
        return Object.values(stockObj).every(qty => qty <= 0);
    } catch(e) {
        return false;
    }
};

const LazyImage = ({ src, alt, eager }) => {
    const [isInView, setIsInView] = useState(eager || false);
    const [isLoaded, setIsLoaded] = useState(false);
    const imgRef = useRef();
    
    useEffect(() => {
        if (eager) {
            setIsInView(true);
            return;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setIsInView(true);
                    observer.disconnect(); 
                }
            },
            { rootMargin: '300px' } 
        );
        if (imgRef.current) observer.observe(imgRef.current);
        return () => { if (observer) observer.disconnect(); };
    }, [eager]);
    
    return (
        <img
            ref={imgRef}
            src={isInView ? src : "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E"} 
            alt={alt}
            onLoad={() => setIsLoaded(true)}
            style={{
                opacity: isLoaded || eager ? 1 : 0,
                transition: eager ? 'none' : 'opacity 0.4s ease-in-out',
                width: '100%', 
                height: '100%',
                objectFit: 'cover',
                display: 'block'
            }}
        />
    );
};

// ==========================================
// 🟢 REUSABLE SWIPEABLE PRODUCT CARD WITH QUICK ADD & DOTS
// ==========================================
const ProductCard = ({ product, eager, addToCart, showToast }) => {
    const navigate = useNavigate();
    const sliderRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const touchStartRef = useRef(0);

    const [isQuickAddOpen, setIsQuickAddOpen] = useState(false);
    const [selectedSize, setSelectedSize] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0); 

    const [showSizeChart, setShowSizeChart] = useState(false);
    const getEffectiveSizeChart = () => {
        if (product.sizeChart && product.sizeChart.trim() !== '') return getOriginalImageUrl(product.sizeChart); 
        const cat = product.category?.toLowerCase() || '';
        if (cat.includes('jeans')) return '/assets/jeans-chart.png';
        if (cat.includes('lower')) return '/assets/lower-chart.png';
        if (cat.includes('shirt') && !cat.includes('tshirt')) return '/assets/shirt-chart.png';
        return '/assets/t shirt chart final.png';
    };

    const images = [product.productImage || product.image];
    if (product.images && product.images.length > 0) {
        images.push(...product.images);
    }
    const validImages = images.filter(Boolean);
    if(validImages.length === 0) validImages.push("/assets/placeholder.jpg");

    const sellingPrice = parseFloat(product.price);
    const actualPrice = parseFloat(product.mrp);
    const hasDiscount = !isNaN(actualPrice) && actualPrice > sellingPrice;
    const discount = hasDiscount ? Math.round(((actualPrice - sellingPrice) / actualPrice) * 100) : 0;
    const isSoldOut = checkSoldOut(product.stock);

    let stockInfo = {};
    try { stockInfo = (typeof product.stock === 'string') ? JSON.parse(product.stock) : product.stock; } 
    catch(e) { stockInfo = {}; }
    const sizes = ["S", "M", "L", "XL"];

    const handleTouchStart = (e) => {
        touchStartRef.current = e.touches[0].clientX;
        setIsDragging(false);
    };

    const handleTouchMove = (e) => {
        const touchCurrent = e.touches[0].clientX;
        if (Math.abs(touchStartRef.current - touchCurrent) > 10) {
            setIsDragging(true);
        }
    };

    const handleScroll = (e) => {
        if (!sliderRef.current) return;
        const scrollLeft = e.target.scrollLeft;
        const width = e.target.clientWidth;
        const newIndex = Math.round(scrollLeft / width);
        if (newIndex !== activeIndex) {
            setActiveIndex(newIndex);
        }
    };

    const handleCardClick = (e) => {
        if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        navigate(`/product/${generateSlug(product.name)}`);
    };

    const handlePlusClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsQuickAddOpen(true);
    };

    const handleQuickAction = (isBuyNow) => {
        if (!selectedSize) {
            if(showToast) showToast("⚠️ Please select a size first!");
            return;
        }
        if ((stockInfo[selectedSize] || 0) <= 0) {
            if(showToast) showToast(`❌ Sorry! Size ${selectedSize} is out of stock.`);
            return;
        }
        if (isBuyNow && window.fbq) {
            window.fbq('track', 'InitiateCheckout', {
                value: sellingPrice,
                currency: 'INR',
                content_name: product.name,
                content_ids: [String(product.id)],
                content_type: 'product'
            });
        }
        if(addToCart) {
            addToCart({ ...product, stock: stockInfo }, selectedSize, isBuyNow);
        }
        setIsQuickAddOpen(false);
        setSelectedSize(null);
    };

    return (
        <div 
            className="product-card" 
            onClick={handleCardClick} 
            onTouchStart={handleTouchStart} 
            onTouchMove={handleTouchMove}
            style={{ cursor: 'pointer' }}
        >
            <div className="card-image" style={{ position: 'relative', overflow: 'hidden' }}>
                
                {isSoldOut && (
                    <span style={{ position: 'absolute', top: '10px', left: '10px', background: 'white', color: 'black', padding: '4px 8px', fontSize: '0.7rem', fontWeight: 'bold', borderRadius: '4px', zIndex: 12, boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                        Sold Out
                    </span>
                )}

                {hasDiscount && !isSoldOut && (
                    <span style={{ 
                        position: 'absolute', 
                        top: '10px', 
                        left: '10px', 
                        backgroundColor: '#f72b2b', 
                        color: 'white', 
                        padding: '4px 8px', 
                        fontSize: '0.75rem', 
                        fontWeight: 'bold', 
                        borderRadius: '8px', 
                        zIndex: 12,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}>
                        Save {discount}%
                    </span>
                )}

                {validImages.length > 1 && (
                    <div style={{ position: 'absolute', bottom: '10px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px', zIndex: 12 }}>
                        {validImages.map((_, i) => (
                            <div  
                                key={i} 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if(sliderRef.current) sliderRef.current.scrollTo({ left: i * sliderRef.current.clientWidth, behavior: 'smooth' });
                                }}
                                style={{ 
                                    width: i === activeIndex ? '7px' : '5px', 
                                    height: i === activeIndex ? '7px' : '5px', 
                                    borderRadius: '50%', 
                                    backgroundColor: '#fff', 
                                    opacity: i === activeIndex ? 1 : 0.5, 
                                    transition: 'all 0.3s ease', 
                                    cursor: 'pointer', 
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.4)'
                                }} 
                            />
                        ))}
                    </div>
                )}
                
                <div 
                    ref={sliderRef} 
                    onScroll={handleScroll}
                    className="hide-scrollbar" 
                    style={{ display: 'flex', overflowX: 'auto', overflowY: 'hidden', scrollSnapType: 'x mandatory', width: '100%', height: '100%', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', touchAction: 'pan-x pan-y' }}
                >
                    {validImages.map((img, idx) => (
                        <div key={idx} style={{ flex: '0 0 100%', width: '100%', height: '100%', scrollSnapAlign: 'start', scrollSnapStop: 'always', position: 'relative' }}>
                            <LazyImage src={getOriginalImageUrl(img)} alt={`${product.name} ${idx}`} eager={eager && idx === 0} />
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="card-info">
                <div className="card-info-header">
                    <h3 style={{ margin: 0 }}>{product.name}</h3>
                    <button className="add-plus-btn" onClick={handlePlusClick}>+</button>
                </div>
                <PriceDisplay price={product.price} mrp={product.mrp} />
            </div>

            {isQuickAddOpen && ReactDOM.createPortal(
                <>
                <div 
                    className="quick-add-overlay" 
                    onClick={(e) => { e.stopPropagation(); setIsQuickAddOpen(false); }}
                    style={{
                        position: 'fixed',
                        top: 0, left: 0,
                        width: '100%', height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 999999
                    }}
                >
                    <div className="quick-add-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="quick-modal-header">
                            <h4>{product.name}</h4>
                            <button onClick={() => setIsQuickAddOpen(false)}>✕</button>
                        </div>
                        
                        <div className="quick-price-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                            <span style={{fontWeight: 'bold', color: 'black'}}>Rs. {sellingPrice}</span>
                            <span 
                                onClick={() => setShowSizeChart(true)} 
                                style={{ fontSize: '0.75rem', fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', color: '#555', letterSpacing: '0.5px' }}
                            >
                                SIZE CHART
                            </span>
                        </div>

                        <div className="quick-size-grid">
                            {sizes.map((size) => {
                                const isOutOfStock = (stockInfo[size] || 0) <= 0;
                                return (
                                    <button key={size} disabled={isOutOfStock} className={`quick-size-btn ${selectedSize === size ? 'active' : ''}`} onClick={() => setSelectedSize(size)}>
                                        {size}
                                    </button>
                                )
                            })}
                        </div>
                        <div className="quick-action-btns">
                            <button className="btn-quick-add" onClick={() => handleQuickAction(false)}>ADD TO BAG</button>
                            <button className="btn-quick-buy" onClick={() => handleQuickAction(true)}>BUY NOW</button>
                        </div>
                    </div>
                </div>

                {showSizeChart && (
                    <div className="size-chart-overlay" onClick={() => setShowSizeChart(false)} style={{ zIndex: 9999999, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="size-chart-modal" onClick={(e) => e.stopPropagation()} style={{ background: '#fff', padding: '15px', borderRadius: '8px', maxWidth: '90%', maxHeight: '85vh', overflowY: 'auto' }}>
                            <div className="chart-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center' }}>
                                <h3 style={{ margin: 0, fontSize: '1.1rem' }}>SIZE GUIDE</h3>
                                <button onClick={() => setShowSizeChart(false)} style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer' }}>✕</button>
                            </div>
                            <div className="chart-image-wrapper">
                                <img src={getEffectiveSizeChart()} alt="Size Chart" className="size-chart-img" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                            </div>
                        </div>
                    </div>
                )}
                </>,
                document.body 
            )}
        </div>
    );
};

// ==========================================
// 🟢 SHOP ALL PAGE
// ==========================================
const ShopPage = ({ addToCart, showToast }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                setLoading(true);
                if (globalProductsCache) {
                    setProducts([...globalProductsCache].reverse());
                    setLoading(false);
                    return;
                }

                const res = await fetch('/api/products/all');
                const data = await res.json();
                globalProductsCache = data; 
                setProducts([...data].reverse());
            } catch(e) { 
                console.error("Error fetching shop products:", e); 
            } finally { 
                setLoading(false); 
            }
        };
        fetchAll();
    }, []);

    if(loading) return <Preloader />;

    return (
        <div className="page-container" style={{paddingTop: '40px'}}>
            <h2 className="section-title">ALL COLLECTIONS</h2>
            <div className="product-container">
                {products.map((product, index) => (
                    <ProductCard key={product.id} product={product} eager={index < 4} addToCart={addToCart} showToast={showToast} />
                ))}
            </div>
        </div>
    );
};

// ==========================================
// 1. SMART CATEGORY PAGE
// ==========================================
const CategoryPage = ({ addToCart, showToast }) => {
    const { type } = useParams(); 
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                let data = globalProductsCache;
                if (!data) {
                    const response = await fetch('/api/products/all');
                    data = await response.json();
                    globalProductsCache = data; 
                }
                const filtered = data.filter(p => p.category.toLowerCase() === type.toLowerCase());
                setProducts(filtered);
            } catch (error) {
                console.error("Error fetching category products:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, [type]);

    if (loading) return <Preloader />;

    if (products.length === 0) {
        return (
            <div style={{height: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginTop: '80px'}}>
                <h1 style={{fontSize: '3rem', color: '#ccc', textTransform: 'uppercase'}}>{type}</h1>
                <h3 style={{fontSize: '1.5rem', color: '#333', marginTop: '10px'}}>COMING SOON</h3>
                <p style={{color: '#666', marginTop:'10px'}}>Stay tuned for the latest drops in {type}.</p>
                <Link to="/" style={{marginTop: '30px', textDecoration: 'underline', fontWeight: 'bold'}}>Back to Home</Link>
            </div>
        );
    }

    return (
        <div className="page-container" style={{paddingTop: '40px'}}>
            <h2 className="section-title" style={{textTransform:'capitalize'}}>{type} Collection</h2>
            <div className="product-container">
                {products.map((product, index) => (
                    <ProductCard key={product.id} product={product} eager={index < 4} addToCart={addToCart} showToast={showToast} />
                ))}
            </div>
        </div>
    );
};

// ==========================================
// 2. PRODUCT DETAILS COMPONENT 
// ==========================================
const ProductDetails = ({ addToCart, showToast }) => {
    const { id } = useParams(); 
    const navigate = useNavigate();
    
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedSize, setSelectedSize] = useState(null);
    const [mainImage, setMainImage] = useState(null);
    const [showSizeChart, setShowSizeChart] = useState(false);
    const [stockInfo, setStockInfo] = useState({}); 
    const [relatedProducts, setRelatedProducts] = useState([]); 

    const [pincode, setPincode] = useState('');
    const [pincodeStatus, setPincodeStatus] = useState(null); 
    const [deliveryDates, setDeliveryDates] = useState('');

    const mainSliderRef = useRef(null);
    const [activeImgIndex, setActiveImgIndex] = useState(0);

    const [accordions, setAccordions] = useState({
        delivery: true,     
        reviews: false      
    });

    const [activeTab, setActiveTab] = useState('details');

    const toggleAccordion = (section) => {
        setAccordions(prev => ({ ...prev, [section]: !prev[section] }));
    };

   useEffect(() => {
        window.scrollTo(0, 0);

        setPincode('');
        setPincodeStatus(null);
        setDeliveryDates('');

        const fetchLiveProduct = async () => {
            try {
                setLoading(true);
                let allProducts = globalProductsCache;
                if (!allProducts) {
                    const response = await fetch(`/api/products/all?t=${Date.now()}`);
                    allProducts = await response.json();
                    globalProductsCache = allProducts; 
                }
                
                const foundProduct = allProducts.find(p => 
                    generateSlug(p.name) === id || p.id === parseInt(id) 
                );

                if (foundProduct) {
                    setProduct(foundProduct);
                    const imgSource = foundProduct.productImage || foundProduct.image; 
                    setMainImage(getOriginalImageUrl(imgSource));
                    setActiveImgIndex(0); 
                    try { setStockInfo(JSON.parse(foundProduct.stock)); } catch(e) { setStockInfo({}); }

                    let galleryImages = [imgSource];
                    if(foundProduct.images && foundProduct.images.length > 0) {
                        galleryImages = [...galleryImages, ...foundProduct.images];
                    }
                    foundProduct.galleryList = galleryImages.map(img => getOriginalImageUrl(img));

                    const related = allProducts
                        .filter(p => p.category === foundProduct.category && p.id !== foundProduct.id)
                        .slice(0, 4);
                    setRelatedProducts(related);
                }
            } catch (error) { console.error("Error fetching details:", error); } 
            finally { 
                setLoading(false); 
                setSelectedSize(null); 
            }
        };
        fetchLiveProduct();
    }, [id]);

    useEffect(() => {
        if (product && window.fbq) {
            const cleanPrice = parseFloat(product.price.toString().replace(/[^0-9.]/g, ''));
            window.fbq('track', 'ViewContent', {
                content_ids: [String(product.id)], 
                content_name: product.name,
                content_type: 'product',
                value: cleanPrice,
                currency: 'INR'
            });
        }
    }, [product]);

    if (loading) return <Preloader />; 
    if (!product) return <div style={{textAlign:'center', marginTop:'150px'}}>Product not found.</div>;
    
    const sizes = ["S", "M", "L", "XL"];
    const sellingPrice = parseFloat(product.price);
    const actualPrice = parseFloat(product.mrp);
    const hasDiscount = !isNaN(actualPrice) && actualPrice > sellingPrice;
    const discountPercent = hasDiscount ? Math.round(((actualPrice - sellingPrice) / actualPrice) * 100) : 0;

    const handleAddToCart = () => {
        if (!selectedSize) { showToast("⚠️ Please select a size first!"); return; }
        const availableQty = stockInfo[selectedSize] || 0;
        if (availableQty <= 0) { showToast(`❌ Sorry! Size ${selectedSize} is out of stock.`); return; }
        addToCart({ ...product, stock: stockInfo }, selectedSize, false); 
    };

    const handleBuyNow = () => {
        if (!selectedSize) { showToast("⚠️ Please select a size first!"); return; }
        const availableQty = stockInfo[selectedSize] || 0;
        if (availableQty <= 0) { showToast(`❌ Sorry! Size ${selectedSize} is out of stock.`); return; }
       
        addToCart({ ...product, stock: stockInfo }, selectedSize, true); 
    };

    const getEffectiveSizeChart = () => {
        if (product.sizeChart && product.sizeChart.trim() !== '') return getOriginalImageUrl(product.sizeChart); 
        const cat = product.category?.toLowerCase() || '';
        if (cat.includes('jeans')) return '/assets/jeans-chart.png';
        if (cat.includes('lower')) return '/assets/lower-chart.png';
        if (cat.includes('shirt') && !cat.includes('tshirt')) return '/assets/shirt-chart.png';
        return '/assets/t shirt chart final.png';
    };

    const calculateDeliveryDates = () => {
        const today = new Date();
        const start = new Date(today);
        start.setDate(today.getDate() + 5);
        const end = new Date(today);
        end.setDate(today.getDate() + 7);
        const options = { day: 'numeric', month: 'short' };
        return `${start.toLocaleDateString('en-US', options)} to ${end.toLocaleDateString('en-US', options)}`;
    };

    const handleCheckPincode = async () => {
        if (pincode.length !== 6) {
            showToast("⚠️ Enter a valid 6-digit pincode!");
            return;
        }
        setPincodeStatus('loading');
        try {
            const response = await fetch("/api/shipping/check-pincode", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ pincode: pincode })
            });
            const data = await response.json();
            if (data && (data.status_code === 1 || data.status === "success" || data?.data?.delivery_type)) {
                setPincodeStatus('available');
                setDeliveryDates(calculateDeliveryDates());
            } else {
                setPincodeStatus('unavailable');
            }
        } catch (error) {
            console.error("Pincode Check Error:", error);
            setPincodeStatus('unavailable'); 
        }
    };

    const handleMainScroll = (e) => {
        if (!mainSliderRef.current) return;
        const scrollLeft = e.target.scrollLeft;
        const width = e.target.clientWidth;
        const newIndex = Math.round(scrollLeft / width);
        if (newIndex !== activeImgIndex) {
            setActiveImgIndex(newIndex);
            if (product && product.galleryList) setMainImage(product.galleryList[newIndex]);
        }
    };

    const handleThumbnailClick = (img, index) => {
        setActiveImgIndex(index);
        setMainImage(img);
        if (mainSliderRef.current) {
            mainSliderRef.current.scrollTo({ left: index * mainSliderRef.current.clientWidth, behavior: 'smooth' });
        }
    };

    return (
        <div className="product-page-wrapper">
        <div className="product-detail-container">
            
            {showSizeChart && (
            <div className="size-chart-overlay" onClick={() => setShowSizeChart(false)}>
                <div className="size-chart-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="chart-header"><h3>SIZE GUIDE</h3><button onClick={() => setShowSizeChart(false)}>✕</button></div>
                    <div className="chart-image-wrapper">
                        <img src={getEffectiveSizeChart()} alt="Size Chart" className="size-chart-img" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                    </div>
                </div>
            </div>
            )}

            <div className="detail-left">
            <div className="main-image-wrapper" style={{ overflow: 'hidden', position: 'relative' }}>
                <div 
                    ref={mainSliderRef} 
                    onScroll={handleMainScroll}
                    className="hide-scrollbar" 
                    style={{ display: 'flex', overflowX: 'auto', overflowY: 'hidden', scrollSnapType: 'x mandatory', width: '100%', height: '100%', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', touchAction: 'pan-x pan-y' }}
                >
                    {product.galleryList && product.galleryList.length > 0 ? (
                        product.galleryList.map((img, idx) => (
                            <div key={idx} style={{ flex: '0 0 100%', width: '100%', height: '100%', scrollSnapAlign: 'start', scrollSnapStop: 'always', position: 'relative' }}>
                                <Zoom key={`zoom-${idx}`}>
                                    <img src={img} alt={`${product.name} ${idx}`} className="active-img" style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }} />
                                </Zoom>
                            </div>
                        ))
                    ) : (
                        <div className="no-image">No Image</div>
                    )}
                </div>
            </div>

            {product.galleryList && product.galleryList.length > 1 && (
                <div className="thumbnail-container">
                    {product.galleryList.map((img, index) => (
                        <div key={index} className={`thumb-box ${activeImgIndex === index ? 'active' : ''}`} onClick={() => handleThumbnailClick(img, index)}>
                            <img src={img} alt={`view ${index}`} />
                        </div>
                    ))}
                </div>
            )}
            </div>

            <div className="detail-right">
            <h1 className="detail-title">{product.name}</h1>
            
            <div style={{margin: '10px 0', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
                {hasDiscount && (
                    <span style={{textDecoration: 'line-through', color: '#999', fontSize: '1.1rem'}}>MRP Rs. {actualPrice}</span>
                )}
                <span className="detail-price" style={{fontSize: '1.5rem', fontWeight: 'bold', color: 'black'}}>Rs. {sellingPrice}</span>
                {hasDiscount && (
                    <span style={{color: 'green', fontWeight: 'bold', fontSize: '1.1rem'}}>(SAVE {discountPercent}%)</span>
                )}
            </div>

            <p className="tax-note">Price inclusive of all taxes</p>
            
            <div className="size-section">
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px'}}>
                    <p className="size-label" style={{marginBottom:0}}>SELECT SIZE</p>
                    <button className="btn-size-chart" onClick={() => setShowSizeChart(true)}>SIZE CHART</button>
                </div>
                <div className="size-grid" style={{gridTemplateColumns: 'repeat(4, 1fr)'}}>
                {sizes.map((size) => {
                    const stockCount = stockInfo[size] || 0;
                    const isOutOfStock = stockCount <= 0;
                    return (
                    <button key={size} disabled={isOutOfStock}
                        className={`size-btn ${selectedSize === size ? 'active' : ''}`} 
                        style={{ opacity: isOutOfStock ? 0.5 : 1, cursor: isOutOfStock ? 'not-allowed' : 'pointer', background: isOutOfStock ? '#eee' : (selectedSize === size ? '#000' : '#fff'), border: isOutOfStock ? '1px solid #ddd' : '1px solid #000', color: selectedSize === size ? '#fff' : (isOutOfStock ? '#aaa' : '#000') }}
                        onClick={() => !isOutOfStock && setSelectedSize(size)}
                    >
                        {size}
                    </button>
                    );
                })}
                </div>
                {selectedSize && stockInfo[selectedSize] <= 0 && (
                    <p style={{fontSize:'0.9rem', marginTop:'10px', fontWeight:'bold', color: 'red'}}>Out of Stock</p>
                )}
            </div>

            <div className="action-buttons">
                <button className="btn-buy" onClick={handleBuyNow} disabled={selectedSize && stockInfo[selectedSize] <= 0}>BUY NOW</button>
                <button className="btn-cart" onClick={handleAddToCart} disabled={selectedSize && stockInfo[selectedSize] <= 0}>ADD TO CART</button>
            </div>

            <div className="trust-badges" style={{ display: 'flex', justifyContent: 'space-around', marginTop: '25px', marginBottom: '15px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '32%' }}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/e/e1/UPI-Logo-vector.svg" alt="UPI" style={{ height: '22px', marginBottom: '8px', objectFit: 'contain' }} />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#333', lineHeight: '1.3' }}>Extra 5% OFF ON<br/>PREPAID</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '32%' }}>
                    <img src="https://img.icons8.com/ios-filled/50/000000/truck.png" alt="Free Shipping" style={{ height: '26px', marginBottom: '4px', objectFit: 'contain' }} />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#333', lineHeight: '1.3' }}>FREE SHIPPING</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '32%' }}>
                    <img src="/assets/1514-cashback-inr (1).svg" alt="COD" style={{ height: '28px', marginBottom: '2px', objectFit: 'contain' }} />
                    <span style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#333', lineHeight: '1.3' }}>COD AVAILABLE</span>
                </div>
            </div>

            <div className="product-accordion-container" style={{ marginTop: '10px', borderTop: '1px solid #eaeaea' }}>
                
                <div className="accordion-item" style={{ borderBottom: '1px solid #eaeaea', backgroundColor: '#fff' }}>
                    <div 
                        className="accordion-header" 
                        onClick={() => toggleAccordion('delivery')} 
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.95rem', textTransform: 'uppercase' }}
                    >
                        <span>Check Delhivery</span>
                        <i className={`fa-solid ${accordions.delivery ? 'fa-minus' : 'fa-plus'}`} style={{fontSize: '1.1rem', color: '#333'}}></i>
                    </div>
                    <AnimatePresence initial={false}>
                        {accordions.delivery && (
                            <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} style={{ overflow: 'hidden' }}>
                                <div style={{ paddingBottom: '20px' }}>
                                    <div style={{ backgroundColor: '#fff', padding: '0', borderRadius: '0' }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', flex: 1, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '0 10px' }}>
                                                <i className="fa-solid fa-location-dot" style={{ color: '#888', marginRight: '8px' }}></i>
                                                <input 
                                                    type="text" 
                                                    placeholder="Enter Pincode" 
                                                    maxLength="6"
                                                    value={pincode}
                                                    onChange={(e) => {
                                                        setPincode(e.target.value.replace(/\D/g, '')); 
                                                        setPincodeStatus(null); 
                                                        setDeliveryDates('');
                                                    }}
                                                    style={{ border: 'none', outline: 'none', width: '100%', padding: '12px 0', fontSize: '0.95rem', backgroundColor: 'transparent' }} 
                                                />
                                            </div>
                                            <button 
                                                onClick={handleCheckPincode}
                                                disabled={pincodeStatus === 'loading'}
                                                style={{ backgroundColor: '#333', color: '#fff', border: 'none', padding: '0 25px', borderRadius: '4px', fontWeight: 'bold', cursor: pincodeStatus === 'loading' ? 'not-allowed' : 'pointer', letterSpacing: '1px', fontSize: '0.85rem' }}
                                            >
                                                {pincodeStatus === 'loading' ? '...' : (pincodeStatus === 'unavailable' ? 'RETRY' : 'CHECK')}
                                            </button>
                                        </div>

                                        {pincodeStatus === 'available' && (
                                            <div style={{ marginTop: '10px', color: 'green', fontSize: '0.85rem', fontWeight: 'bold' }}>
                                                ✅ Delivery available. Expected delivery date is {deliveryDates}.
                                            </div>
                                        )}
                                        {pincodeStatus === 'unavailable' && (
                                            <div style={{ marginTop: '10px', color: '#d32f2f', fontSize: '0.85rem', fontWeight: 'bold' }}>
                                                Sorry, delivery not available for this pincode.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                <div style={{ marginTop: '20px', marginBottom: '20px', border: '1px solid #eaeaea', borderRadius: '8px', overflow: 'hidden' }}>
                    
                    <div style={{ display: 'flex', borderBottom: '1px solid #ddd', backgroundColor: '#f5f5f5' }}>
                        <div 
                            onClick={() => setActiveTab('details')}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, textAlign: 'center', padding: '12px 5px', fontSize: '0.85rem', fontWeight: activeTab === 'details' ? 'bold' : '600', color: activeTab === 'details' ? '#000' : '#666', borderBottom: activeTab === 'details' ? '2px solid #000' : '2px solid transparent', cursor: 'pointer', transition: 'all 0.3s' }}
                        >
                            Details & Description
                        </div>
                        <div 
                            onClick={() => setActiveTab('washcare')}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, textAlign: 'center', padding: '12px 5px', fontSize: '0.85rem', fontWeight: activeTab === 'washcare' ? 'bold' : '600', color: activeTab === 'washcare' ? '#000' : '#666', borderBottom: activeTab === 'washcare' ? '2px solid #000' : '2px solid transparent', cursor: 'pointer', transition: 'all 0.3s' }}
                        >
                            Washcare
                        </div>
                        <div 
                            onClick={() => setActiveTab('shipping')}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, textAlign: 'center', padding: '12px 5px', fontSize: '0.85rem', fontWeight: activeTab === 'shipping' ? 'bold' : '600', color: activeTab === 'shipping' ? '#000' : '#666', borderBottom: activeTab === 'shipping' ? '2px solid #000' : '2px solid transparent', cursor: 'pointer', transition: 'all 0.3s' }}
                        >
                            Shipping
                        </div>
                    </div>

                    <div style={{ padding: '20px 15px', color: '#444', fontSize: '0.9rem', lineHeight: '1.8', minHeight: '120px', backgroundColor: '#f5f5f5' }}>
                        
                        {activeTab === 'details' && (
                            <div style={{ whiteSpace: 'pre-line', color: '#333' }}>
                                {product.description || "No description available for this product."}
                            </div>
                        )}

                        {activeTab === 'washcare' && (
                            <div style={{ whiteSpace: 'pre-line', color: '#333' }}>
                                {product.washcare || "No washcare instructions available for this product."}
                            </div>
                        )}

                        {activeTab === 'shipping' && (
                            <div style={{ whiteSpace: 'pre-line', color: '#333' }}>
                                {product.shippingPolicy || "No shipping policy available for this product."}
                            </div>
                        )}

                    </div>
                </div>

                <div className="accordion-item" style={{ borderBottom: '1px solid #eaeaea', backgroundColor: '#fff' }}>
                    <div 
                        className="accordion-header" 
                        onClick={() => toggleAccordion('reviews')} 
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.95rem', textTransform: 'uppercase' }}
                    >
                        <span>Customer Reviews</span>
                        <i className={`fa-solid ${accordions.reviews ? 'fa-minus' : 'fa-plus'}`} style={{fontSize: '1.1rem', color: '#333'}}></i>
                    </div>
                    <AnimatePresence initial={false}>
                        {accordions.reviews && (
                            <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} style={{ overflow: 'hidden' }}>
                                <div style={{ paddingBottom: '20px' }}>
                                    <ProductReview productId={product.id} />
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

            </div>

            </div>
        </div>

        {relatedProducts.length > 0 && (
            <div style={{marginTop: '15px', padding: '0 5px', marginBottom: '10px', overflow: 'hidden'}}>
                <h2 className="section-title" style={{textAlign: 'center', marginBottom: '10px'}}>YOU MAY ALSO LIKE</h2>
                <div className="product-container">
                    {relatedProducts.map((rp, index) => (
                        <ProductCard key={rp.id} product={rp} eager={index < 4} addToCart={addToCart} showToast={showToast} />
                    ))}
                </div>
            </div>
        )}
        </div>
    );
};

// ==========================================
// 3. HOME PAGE 
// ==========================================

const Home = ({ addToCart, showToast }) => {
    const [products, setProducts] = useState([]);
    const [visibleCount, setVisibleCount] = useState(12);
    const [carouselImages, setCarouselImages] = useState({ desktop: [], mobile: [] }); 
    const [isFetching, setIsFetching] = useState(true); 

    const [currentDesktop, setCurrentDesktop] = useState(0);
    const [currentMobile, setCurrentMobile] = useState(0);

    const [touchStartD, setTouchStartD] = useState(0);
    const [touchStartM, setTouchStartM] = useState(0);

    const navigate = useNavigate();
    const location = useLocation(); 

    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('q'); 

    useEffect(() => { 
        const fetchHomeProductsAndCarousel = async () => {
            setIsFetching(true); 
            try {
                let data = globalProductsCache;
                if (!data) {
                    const response = await fetch('/api/products/all');
                    data = await response.json();
                    globalProductsCache = data; 
                }
                
                if (searchQuery) {
                    const filtered = data.filter(p => 
                        p.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
                        p.category.toLowerCase().includes(searchQuery.toLowerCase())
                    );
                    setProducts(filtered);
                } else {
                    setProducts([...data].reverse());
                }

                if (globalCarouselCache) {
                    setCarouselImages(globalCarouselCache);
                } else {
                    const carRes = await fetch('/api/carousel/all');
                    if (carRes.ok) {
                        const carData = await carRes.json();
                        const desktop = carData.filter(img => img.type === 'DESKTOP').slice(0, 3);
                        const mobile = carData.filter(img => img.type === 'MOBILE').slice(0, 4);
                        globalCarouselCache = { desktop, mobile }; 
                        setCarouselImages(globalCarouselCache);
                    }
                }
            } catch (error) { 
                console.error("Error:", error); 
            } finally {
                setIsFetching(false); 
            }
        };
        fetchHomeProductsAndCarousel();
    }, [searchQuery]); 

    const fallbackDesktop = [
        { id: 'f1', imageUrl: '/assets/carousel2/1%20desktop.webp' },
        { id: 'f2', imageUrl: '/assets/carousel2/2%20desktop.webp' },
        { id: 'f3', imageUrl: '/assets/carousel2/3%20desktop.webp' }
    ];
    const fallbackMobile = [
        { id: 'm1', imageUrl: '/assets/carousel2/1%20mobile.webp' },
        { id: 'm2', imageUrl: '/assets/carousel2/2%20mobile.webp' },
        { id: 'm3', imageUrl: '/assets/carousel2/3%20mobile.webp' },
        { id: 'm4', imageUrl: '/assets/carousel2/4%20mobile.webp' }
    ];

    const activeDesktopImages = carouselImages.desktop.length > 0 ? carouselImages.desktop : fallbackDesktop;
    const activeMobileImages = carouselImages.mobile.length > 0 ? carouselImages.mobile : fallbackMobile;

    useEffect(() => {
        if (activeDesktopImages.length <= 1) return; 
        const timer = setInterval(() => {
            setCurrentDesktop(prev => (prev + 1) % activeDesktopImages.length);
        }, 4000); 
        return () => clearInterval(timer);
    }, [activeDesktopImages.length]);

    useEffect(() => {
        if (activeMobileImages.length <= 1) return; 
        const timer = setInterval(() => {
            setCurrentMobile(prev => (prev + 1) % activeMobileImages.length);
        }, 4000);
        return () => clearInterval(timer);
    }, [activeMobileImages.length]);

    const handleDiscoverMore = () => { setVisibleCount(products.length); };
    const handleShopNow = () => { navigate('/shop'); };

    const handleTouchStartDesktop = (e) => setTouchStartD(e.touches[0].clientX);
    const handleTouchEndDesktop = (e) => {
        const touchEnd = e.changedTouches[0].clientX;
        if (touchStartD - touchEnd > 50) setCurrentDesktop(p => (p + 1) % activeDesktopImages.length);
        if (touchStartD - touchEnd < -50) setCurrentDesktop(p => (p - 1 + activeDesktopImages.length) % activeDesktopImages.length);
    };

    const handleTouchStartMobile = (e) => setTouchStartM(e.touches[0].clientX);
    const handleTouchEndMobile = (e) => {
        const touchEnd = e.changedTouches[0].clientX;
        if (touchStartM - touchEnd > 50) setCurrentMobile(p => (p + 1) % activeMobileImages.length);
        if (touchStartM - touchEnd < -50) setCurrentMobile(p => (p - 1 + activeMobileImages.length) % activeMobileImages.length);
    };

    // 🟢 NAYA CODE: Jab tak API se data na aa jaye, sirf Loading Logo dikhega!
    if (isFetching) {
        return <Preloader />;
    }

    return (
        <>
        {!searchQuery && (
            <>
                <div 
                    className="carousel desktop-carousel" 
                    style={{ position: 'relative', background: '#f5f5f5' }}
                    onTouchStart={handleTouchStartDesktop}
                    onTouchEnd={handleTouchEndDesktop}
                >
                    {activeDesktopImages.map((img, index) => (
                        <img 
                            key={img.id || index} 
                            src={img.imageUrl || img.image || ""} 
                            alt={`Desktop Slide ${index + 1}`} 
                            style={{
                                position: index === 0 ? 'relative' : 'absolute',
                                top: 0, left: 0,
                                width: '100%', height: '100%', objectFit: 'cover',
                                opacity: index === currentDesktop ? 1 : 0, 
                                transition: 'opacity 0.6s ease-in-out',
                                animation: 'none', 
                                zIndex: index === currentDesktop ? 1 : 0,
                                display: 'block'
                            }}
                        />
                    ))}

                    <div className="carousel-overlay" style={{ zIndex: 10 }}>
                        <div className="center-button-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <button 
                                className="shop-now-btn" 
                                onClick={handleShopNow}
                                style={{ 
                                    backgroundColor: 'transparent', 
                                    outline: 'none', 
                                    WebkitTapHighlightColor: 'transparent', 
                                    boxShadow: 'none',
                                    marginTop: '260px' 
                                }}
                            >
                                SHOP NOW
                            </button>
                        </div>
                    </div>
                </div>

                
    <div 
        className="carousel mobile-carousel" 
        style={{ 
            position: 'relative', 
            background: '#f5f5f5', 
            height: '70vh', 
            overflow: 'hidden',
            touchAction: 'pan-y' 
        }}
        onTouchStart={handleTouchStartMobile}
        onTouchEnd={handleTouchEndMobile}
    >
        {activeMobileImages.map((img, index) => (
            <div 
                key={img.id || index} 
                className="mobile-bg-img"
                style={{
                    position: index === 0 ? 'relative' : 'absolute',
                    top: 0, left: 0,
                    width: '100%', height: '100%',
                    backgroundImage: `url(${img.imageUrl || img.image || ""})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top center',
                    opacity: index === currentMobile ? 1 : 0,
                    transition: 'opacity 0.6s ease-in-out',
                    zIndex: index === currentMobile ? 1 : 0
                }}
            />
        ))}

        <div style={{ 
            position: 'absolute', 
            top: 0, left: 0, 
            width: '100%', height: '100%', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            zIndex: 10, 
            pointerEvents: 'none' 
        }}>
            <button 
                className="shop-now-btn" 
                onClick={() => navigate('/shop')} 
                style={{
                    backgroundColor: 'transparent',
                    color: '#fff',
                    border: 'none',
                    borderBottom: '1px solid #fff', 
                    padding: '5px 10px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    pointerEvents: 'auto',
                    marginTop: '240px' 
                }}
            >
                SHOP NOW
            </button>
        </div>
    </div>
            </>
        )}

        <h2 className="section-title">
            {searchQuery ? `Search Results for "${searchQuery}"` : "New Arrivals "}
        </h2>

        <div className="product-container">
            {products.length === 0 ? (
                <p style={{textAlign:'center', width:'100%', padding:'50px'}}>
                    {searchQuery ? "No products found." :""}
                </p>
            ) : (
            products.slice(0, visibleCount).map((product, index) => (
                <ProductCard key={product.id} product={product} eager={index < 2} addToCart={addToCart} showToast={showToast} />
            )))}
        </div>
        
        {!searchQuery && visibleCount < products.length && (
            <div style={{textAlign: 'center', marginBottom: '60px', marginTop: '20px'}}>
                <button onClick={handleDiscoverMore} className="btn-black" style={{width: 'auto', padding: '15px 40px', borderRadius: '30px', fontSize: '0.9rem'}}>DISCOVER MORE</button>
            </div>
        )}
        </>
    );
};

// ==========================================
// 4. MAIN APP LOGIC
// ==========================================
function MainContent() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isMenDropdownOpen, setIsMenDropdownOpen] = useState(false);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isScrolled, setIsScrolled] = useState(false);
    
    // 🟢 Background Loader ke liye
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 30) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    
    const [isMobileTopwearOpen, setIsMobileTopwearOpen] = useState(false);
    const [isMobileBottomwearOpen, setIsMobileBottomwearOpen] = useState(false);
    
    const [user, setUser] = useState(null);
    const [cart, setCart] = useState([]);
    const navigate = useNavigate();

    const location = useLocation();
    const isHomePage = location.pathname === '/';

    const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/create-admin');

    const [isSiteLoading, setIsSiteLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsSiteLoading(false);
        }, 500); 
        return () => clearTimeout(timer);
    }, []);

    const [toast, setToast] = useState({ message: '', visible: false });

    const showToast = (message) => {
        setToast({ message, visible: true });
        setTimeout(() => { setToast({ message: '', visible: false }); }, 3000);
    };

    const [openFooterSection, setOpenFooterSection] = useState(null);
    const toggleFooter = (section) => {
        if (openFooterSection === section) { setOpenFooterSection(null); } 
        else { setOpenFooterSection(section); }
    };

    useEffect(() => {
        const savedUser = localStorage.getItem("user");
        if (savedUser) {
            const userData = JSON.parse(savedUser);
            setUser(userData);
            fetchCart(userData.username);
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            setCart(guestCart);
        }
    }, []);

    const fetchCart = async (username) => {
        try {
            const res = await fetch(`https://antarvaani.com/api/cart/user/${username}?t=${Date.now()}`, {
                headers: { 'Cache-Control': 'no-cache' }
            });
            if(res.ok) { 
                const data = await res.json(); 
                setCart(data); 
            }
        } catch(err) { console.error("Fetch Cart Error", err); }
    };

    const addToCart = async (product, size, isBuyNow = false) => {
        let maxStock = 0;
        try {
            const stockObj = (typeof product.stock === 'string') ? JSON.parse(product.stock) : product.stock;
            maxStock = stockObj[size] || 0;
        } catch(e) { maxStock = 0; }

        if (maxStock <= 0) { showToast("❌ Out of Stock!"); return; }

        // 🟢 Magic Checkout for "Buy Now"
        if (isBuyNow) {
            const sellingPrice = parseFloat(product.price.toString().replace(/[^0-9.]/g, ''));
            
            
            
            // 🟢 SAFELY FETCH PRODUCT IMAGE
            const productImageUrl = getRazorpaySafeImageUrl(product.productImage || product.image);

            try {
                const res = await fetch("https://antarvaani.com/api/orders/create-razorpay-order", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ 
                        line_items: [
                            {
                                name: product.name,
                                description: `Size: ${size}`,
                                amount: sellingPrice * 100,
                                currency: "INR",
                                quantity: 1,
                                image_url: productImageUrl 
                            }
                        ]
                    })
                });
                const orderDataFromBackend = await res.json(); 
                const razorpayOrderId = orderDataFromBackend.id; 

                const options = {
                    key: "rzp_live_S9zcGwEtjiM41d", 
                    amount: sellingPrice * 100, 
                    currency: "INR",
                    name: "Antarvaani",
                    description: `${product.name} (Size: ${size})`,
                    
                    // 🟢 LOGO FIX
                    image: window.location.origin + "/favicon-512.png",
                    theme: { color: "#2D68FF" },
                    
                    order_id: razorpayOrderId,
                    one_click_checkout: true, 

                    line_items: [
                        {
                            name: product.name,
                            description: `Size: ${size}`,
                            amount: sellingPrice * 100,
                            currency: "INR",
                            quantity: 1,
                            image_url: productImageUrl 
                        }
                    ],

                    prefill: {
                        name: user ? user.username : "",
                        email: user ? user.email : "",
                        contact: user ? user.phone : ""
                    },
                    
                    handler: async function (response) {
                        setIsProcessingPayment(true); // 🟢 Show Loader
                        showToast("✅ Payment Successful! Fetching details...");
                        if (window.fbq) {
                            window.fbq('track', 'Purchase', {
                                value: sellingPrice,
                                currency: 'INR',
                                content_name: product.name,
                                content_ids: [String(product.id)],
                                content_type: 'product',
                                num_items: 1
                            });
                        }
                        
                        const orderData = {
                            username: user ? user.username : "Fetch_From_Razorpay",
                            totalAmount: sellingPrice,
                            orderItems: JSON.stringify([{ id: product.id, name: product.name, size: size, qty: 1, price: sellingPrice }]),
                            paymentMode: "Razorpay Magic",
                            razorpayOrderId: response.razorpay_order_id,
                            razorpayPaymentId: response.razorpay_payment_id,
                        };

                        try {
                            const resBackend = await fetch("https://antarvaani.com/api/orders/place", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(orderData)
                            });
                            
                            const savedOrder = await resBackend.json();

                            let finalPaymentMode = savedOrder.paymentMode || "Online / Prepaid";
                        let finalAmount = sellingPrice;

                        if (finalPaymentMode.toUpperCase().includes("COD")) {
                            finalAmount = sellingPrice + 99; // COD par 99 extra
                        } else {
                            finalAmount = Math.round(sellingPrice - (sellingPrice * 0.05)); // Prepaid par 5% discount
                        }

                            const confirmData = {
                            id: savedOrder.id || response.razorpay_order_id,
                            name: savedOrder.username !== "Guest" ? savedOrder.username : (savedOrder.email ? savedOrder.email.split('@')[0] : "Customer"),
                            phone: savedOrder.phone || "N/A",
                            email: savedOrder.email || "N/A",
                            paymentMethod: finalPaymentMode,
                            totalAmount: finalAmount, // 🟢 YAHAN UPDATE KIYA
                            address: savedOrder.address && savedOrder.address !== "Address Pending Verification" ? `${savedOrder.address}, ${savedOrder.city || ''}, ${savedOrder.pincode || ''}` : "Address securely captured via Razorpay",
                            items: [{ name: product.name, image: getOriginalImageUrl(product.productImage || product.image), size: size, qty: 1 }]
                        };

                            setIsProcessingPayment(false); // 🟢 Hide Loader
                            navigate("/order-confirmation", { state: { orderData: confirmData } });
                        } catch (err) {
                            setIsProcessingPayment(false);
                            showToast("⚠️ Order placed but failed to load details.");
                        }
                    }
                };

                const rzp = new window.Razorpay(options);
                rzp.on('payment.failed', function (response){
                    showToast("❌ Payment Failed. Please try again.");
                });
                rzp.open();

            } catch (error) {
                console.error(error);
                showToast("⚠️ Checkout initialization failed!");
            }
            return; 
        }

        // --- Normal Add To Cart Logic ---
        if (user) {
            const dbCartItem = {
                username: user.username,
                productId: product.id,
                productName: product.name,
                price: parseFloat(product.price.toString().replace(/[^0-9.]/g, '')),
                image: product.productImage || product.image || "",
                size: size,
                qty: 1
            };

            try {
                const response = await fetch('https://antarvaani.com/api/cart/add', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(dbCartItem)
                });

                if (response.ok) {
                    await fetchCart(user.username); 
                    
                    if (window.fbq) {
                        window.fbq('track', 'AddToCart', {
                            content_ids: [String(product.id)],
                            content_name: product.name,
                            value: parseFloat(product.price.toString().replace(/[^0-9.]/g, '')),
                            currency: 'INR'
                        });
                    }

                    setTimeout(() => {
                        setIsCartOpen(true); showToast("✅ Product Added Successfully!");
                    }, 50);
                } else {
                    showToast("❌ Failed to add product.");
                }
            } catch (error) { showToast("⚠️ Server Connection Error!"); }
        } 
        else {
            const guestCartItem = {
                id: `guest-${Date.now()}`,
                productId: product.id,
                productName: product.name,
                price: parseFloat(product.price.toString().replace(/[^0-9.]/g, '')),
                image: product.productImage || product.image || "",
                size: size,
                qty: 1,
                maxStock: maxStock 
            };

            let currentGuestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            
            const existingItemIndex = currentGuestCart.findIndex(item => item.productId === guestCartItem.productId && item.size === guestCartItem.size);
            
            if (existingItemIndex >= 0) {
                if (currentGuestCart[existingItemIndex].qty + 1 > maxStock) {
                    showToast(`❌ Only ${maxStock} item(s) left in stock!`);
                    return; 
                }
                currentGuestCart[existingItemIndex].qty += 1;
                currentGuestCart[existingItemIndex].maxStock = maxStock; 
            } else {
                currentGuestCart.push(guestCartItem);
            }

            localStorage.setItem('guestCart', JSON.stringify(currentGuestCart));
            setCart(currentGuestCart);

            if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                    content_ids: [String(product.id)],
                    content_name: product.name,
                    value: parseFloat(product.price.toString().replace(/[^0-9.]/g, '')),
                    currency: 'INR'
                });
            }

            setTimeout(() => {
                setIsCartOpen(true); showToast("✅ Product Added to Cart!");
            }, 50);
        }
    };

    const updateQuantity = async (cartItemId, change, currentQty) => {
        const newQty = currentQty + change;
        if (newQty < 1) return; 

        if (user) {
            setCart(cart.map(item => item.id === cartItemId ? { ...item, qty: newQty } : item));
            try {
                const response = await fetch(`https://antarvaani.com/api/cart/update/${cartItemId}/${newQty}`, { method: 'PUT' });
                if (!response.ok) {
                    const errorMsg = await response.text();
                    showToast("⚠️ " + errorMsg);
                    fetchCart(user.username); 
                }
            } catch (error) { console.error("Qty Update Error:", error); fetchCart(user.username); }
        } else {
            let currentGuestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            const itemToUpdate = currentGuestCart.find(item => item.id === cartItemId);
            
            if (itemToUpdate) {
                if (change > 0 && itemToUpdate.maxStock && newQty > itemToUpdate.maxStock) {
                    showToast(`❌ Only ${itemToUpdate.maxStock} item(s) left in stock!`);
                    return; 
                }
                itemToUpdate.qty = newQty;
                localStorage.setItem('guestCart', JSON.stringify(currentGuestCart));
                setCart(currentGuestCart);
            }
        }
    };

    const removeFromCart = async (cartItemId) => {
        if (user) {
            try {
                await fetch(`https://antarvaani.com/api/cart/delete/${cartItemId}`, { method: 'DELETE' });
                fetchCart(user.username); 
            } catch(err) { console.error("Delete Error", err); }
        } else {
            let currentGuestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            currentGuestCart = currentGuestCart.filter(item => item.id !== cartItemId);
            localStorage.setItem('guestCart', JSON.stringify(currentGuestCart));
            setCart(currentGuestCart);
        }
    };

    const clearCart = () => setCart([]); 

    const handleLogout = () => {
        localStorage.removeItem("user");
        setUser(null);
        
        const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
        setCart(guestCart);

        setIsProfileOpen(false);
        showToast("✅ Logout Successfully"); 
        navigate("/");
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter' && searchQuery.trim() !== "") {
        navigate(`/search?q=${searchQuery}`);
        setIsSearchOpen(false); 
        }
    };

    const closeAllMenus = () => { setIsSidebarOpen(false); setIsCartOpen(false); setIsSearchOpen(false); setIsMenDropdownOpen(false); setIsProfileOpen(false); };
    
    // 🟢 Magic Checkout for CART
    const goToCheckout = async () => { 
        if (cart.length === 0) {
            showToast("⚠️ Your cart is empty!");
            return;
        }

        setIsCartOpen(false); 

        const cartTotal = cart.reduce((total, item) => total + (item.price * item.qty), 0);

        

        // 🟢 SAFELY FETCH PRODUCT IMAGES
        const orderItemsList = cart.map(item => ({
            name: item.productName,
            description: `Size: ${item.size}`,
            amount: item.price * 100,
            currency: "INR",
            quantity: item.qty,
            image_url: getRazorpaySafeImageUrl(item.image) 
        }));

        try {
            const res = await fetch("https://antarvaani.com/api/orders/create-razorpay-order", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    line_items: orderItemsList
                }) 
            });
            const orderDataFromBackend = await res.json(); 
            const razorpayOrderId = orderDataFromBackend.id; 

            const options = {
                key: "rzp_live_S9zcGwEtjiM41d", 
                amount: cartTotal * 100, 
                currency: "INR",
                name: "Antarvaani",
                description: `Cart Checkout (${cart.length} items)`,
                
                // 🟢 LOGO FIX
                image: window.location.origin + "/favicon-512.png",
                theme: { color: "#2D68FF" },

                order_id: razorpayOrderId,
                one_click_checkout: true, 
                
                line_items: orderItemsList,

                prefill: {
                    name: user ? user.username : "",
                    email: user ? user.email : "",
                    contact: user ? user.phone : ""
                },
                
                handler: async function (response) {
                    setIsProcessingPayment(true); // 🟢 Show Loader
                    showToast("✅ Payment Successful! Fetching details...");
                    if (window.fbq) { 
                        const contentIds = cart.map(item => String(item.productId));
                        window.fbq('track', 'Purchase', { 
                            content_ids: contentIds,
                            content_type: 'product',
                            value: cartTotal, 
                            currency: 'INR', 
                            num_items: cart.length 
                        }); 
                    }
                    
                    const dbFormattedItems = cart.map(item => ({
                        id: item.productId,
                        name: item.productName,
                        size: item.size,
                        qty: item.qty
                    }));

                    const orderData = {
                        username: user ? user.username : "Fetch_From_Razorpay",
                        totalAmount: cartTotal,
                        orderItems: JSON.stringify(dbFormattedItems),
                        paymentMode: "Razorpay Magic",
                        razorpayOrderId: response.razorpay_order_id,
                        razorpayPaymentId: response.razorpay_payment_id,
                    };

                    try {
                        const resBackend = await fetch("https://antarvaani.com/api/orders/place", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(orderData)
                        });
                        
                        const savedOrder = await resBackend.json();
                        let finalPaymentMode = savedOrder.paymentMode || "Online / Prepaid";
                        let finalAmount = cartTotal;

                        if (finalPaymentMode.toUpperCase().includes("COD")) {
                            finalAmount = cartTotal + 99; // COD par 99 extra
                        } else {
                            finalAmount = Math.round(cartTotal - (cartTotal * 0.05)); // Prepaid par 5% discount
                        }

                        const confirmData = {
                            id: savedOrder.id || response.razorpay_order_id,
                            name: savedOrder.username !== "Guest" ? savedOrder.username : (savedOrder.email ? savedOrder.email.split('@')[0] : "Customer"),
                            phone: savedOrder.phone || "N/A",
                            email: savedOrder.email || "N/A",
                            paymentMethod: finalPaymentMode,
                            totalAmount: finalAmount, // 🟢 YAHAN UPDATE KIYA
                            address: savedOrder.address && savedOrder.address !== "Address Pending Verification" ? `${savedOrder.address}, ${savedOrder.city || ''}, ${savedOrder.pincode || ''}` : "Address securely captured via Razorpay",
                            items: cart.map(item => { return { name: item.productName, image: getOriginalImageUrl(item.image), size: item.size, qty: item.qty }; })
                        };

                        clearCart();
                        setIsProcessingPayment(false); // 🟢 Hide Loader
                        navigate("/order-confirmation", { state: { orderData: confirmData } });
                    } catch (err) {
                        setIsProcessingPayment(false);
                        showToast("⚠️ Order placed but failed to load details.");
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.on('payment.failed', function (response){
                showToast("❌ Payment Failed. Please try again.");
            });
            rzp.open();

        } catch (error) {
            console.error(error);
            showToast("⚠️ Checkout initialization failed!");
        }
    };
    
    const openCart = () => { setIsCartOpen(true); };
    const isAdmin = user && user.role === 'ADMIN';

    const isTransparent = isHomePage && !isScrolled;
    const navTextColor = isTransparent ? '#ffffff' : '#000000';

    if (isSiteLoading) {
        return <Preloader />;
    }

    const globalStyles = `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
    `;

    return (
        <div className="App">
        <style>{globalStyles}</style>
        <ScrollToTop />

        {/* 🟢 FULL SCREEN LOADER: Order process hone ke beech mein Home page nahi dikhega */}
        {isProcessingPayment && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(255, 255, 255, 0.95)', zIndex: 999999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ border: '4px solid #f3f3f3', borderTop: '4px solid #000', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite', marginBottom: '20px' }}></div>
                <h2 style={{ color: '#000', margin: '0 0 10px', fontSize: '1.5rem', fontFamily: 'sans-serif' }}>Processing Your Order...</h2>
                <p style={{ color: '#666', margin: 0, fontWeight: '500', fontFamily: 'sans-serif' }}>Please do not refresh or close this page.</p>
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
        )}
        
        {toast.visible && (
            <div style={{ position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#333', color: '#fff', padding: '12px 24px', borderRadius: '8px', zIndex: 10000, boxShadow: '0 4px 6px rgba(0,0,0,0.1)', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '0.9rem', minWidth: '280px', justifyContent: 'center', animation: 'fadeIn 0.3s ease' }}>
                {toast.message}
            </div>
        )}

        <nav 
    className={isAdmin ? "Navbar admin-nav" : "Navbar"}
    style={{
        backgroundColor: isTransparent ? 'rgba(0, 0, 0, 0.15)' : '#ffffff', 
        backdropFilter: isTransparent ? 'blur(1px)' : 'none',
        WebkitBackdropFilter: isTransparent ? 'blur(1px)' : 'none',
        position: isHomePage ? 'fixed' : 'sticky',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 9999,
        transition: 'all 0.4s ease-in-out', 
        boxShadow: isTransparent ? 'none' : '0 2px 10px rgba(0,0,0,0.05)'
    }}
    >
    <div className="Nav-left">
        {!isAdmin && (
            <img 
                src={isTransparent ? '/assets/header-icons/white-line.svg' : '/assets/header-icons/Black-line.svg'} 
                className="mobile-menu-icon" 
                onClick={() => setIsSidebarOpen(true)} 
                style={{ height: '20px', width: '20px', cursor: 'pointer', marginLeft: '10px', transition: 'all 0.3s' }} 
                alt="Menu"
            />
        )}
        <div className="logo-wrapper">
        <Link to={isAdmin ? "/admin" : "/"} className="brand-link" style={{display: 'flex', alignItems: 'center'}}>
            <img 
                src={isTransparent ? '/assets/header-icons/ANTARVAANI WHITE SVG.svg' : '/assets/header-icons/ANTARVAANI BLACK SVG.svg'} 
                alt="ANTARVAANI" 
                style={{ height: '30px', marginLeft: '5px', objectFit: 'contain', width:'380px', transition: 'all 0.3s' }} 
            />
        </Link>
        </div>
    </div>

    <div className="Nav-center">
        {isAdmin ? (
        <div style={{color: navTextColor, fontSize: '1.2rem', fontWeight: 'bold', border: `1px solid ${navTextColor}`, padding: '5px 15px', letterSpacing: '2px'}}>ADMIN</div>
        ) : (
        <div className="men-section-wrapper" onClick={(e) => { e.stopPropagation(); setIsMenDropdownOpen(!isMenDropdownOpen); }}>
            <span style={{cursor:'pointer', fontWeight:'600', fontSize:'0.9rem', letterSpacing:'1px', color: navTextColor, transition: 'color 0.4s ease-in-out'}} id="men-btn">CATEGORY</span>
            <div className={`men-dropdown ${isMenDropdownOpen ? 'active' : ''}`}>
            <ul>
                <li><Link to="/category/tshirt" onClick={() => setIsMenDropdownOpen(false)}>T-Shirts</Link></li>
                <li><Link to="/category/shirt" onClick={() => setIsMenDropdownOpen(false)}>Shirts</Link></li>
                <li><Link to="/category/jeans" onClick={() => setIsMenDropdownOpen(false)}>Jeans</Link></li>
                <li><Link to="/category/Polo-Tshirt" onClick={() => setIsMenDropdownOpen(false)}>Polo-Tshirt</Link></li>
                <li><Link to="/category/lower" onClick={() => setIsMenDropdownOpen(false)}>Lowers</Link></li>
            </ul>
            </div>
        </div>
        )}
    </div>

    <div className="Nav-right" style={{ display: 'flex', alignItems: 'center', gap: '15px', paddingRight: '10px' }}>
        {!isAdmin && (
        <>
            <img 
                src={isTransparent ? '/assets/header-icons/white-search.svg' : '/assets/header-icons/Black-search.svg'} 
                id="search-icon" 
                onClick={() => setIsSearchOpen(!isSearchOpen)} 
                style={{ width: '18px', cursor: 'pointer', transition: 'all 0.3s' }} 
                alt="Search" 
            />
            <div className="desktop-search"><input type="search" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} onKeyDown={handleSearch} /></div>
        </>
        )}
        
        {user && !isAdmin && <div className="desktop-only" style={{display:'flex', alignItems:'center', gap:'10px'}}><span className="desktop-user-info" style={{ color: navTextColor, transition: 'color 0.4s' }}>{`HI, ${user.username.toUpperCase()}`}</span></div>}
        
        {!user && <span className="desktop-link desktop-only"><Link to="/login" style={{textDecoration:'none', fontWeight:'800', fontSize:'0.9rem', letterSpacing:'1px', color: navTextColor, transition: 'color 0.4s ease-in-out'}}>LOGIN</Link></span>}
        
        {!isAdmin && (
        <div className="cart-icon-wrapper" onClick={(e) => { e.preventDefault(); setIsCartOpen(true); }} style={{ position: 'relative' }}>
            <img 
                src={isTransparent ? '/assets/header-icons/cart-white.svg' : '/assets/header-icons/black.svg'} 
                alt="Cart" 
                style={{ width: '17px', cursor: 'pointer', marginBottom: '2px', transition: 'all 0.3s' }} 
            />
            {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
        </div>
        )}
        <i className={`user-icon ${isAdmin ? 'admin-icon' : ''}`} onClick={(e) => { e.preventDefault(); if(user) setIsProfileOpen(true); else navigate('/login'); }}>
        <i className="fa-solid fa-user" style={{fontSize: isAdmin ? '1.2rem' : '1.1rem', color: navTextColor, transition: 'color 0.4s ease-in-out'}}></i>
        </i>
    </div>
    </nav>

        <div className={`search-dropdown ${isSearchOpen ? 'active' : ''}`}>
            <div className="search-container-wrapper">
                <input 
                    type="text" 
                    placeholder="Search..." 
                    value={searchQuery} 
                    onChange={(e) => setSearchQuery(e.target.value)} 
                    onKeyDown={handleSearch} 
                    className="search-input-box"
                />
                <i 
                    className="fa-solid fa-xmark close-search-icon" 
                    onClick={() => {
                        setIsSearchOpen(false);
                        setSearchQuery("");
                    }}
                ></i>
            </div>
        </div>
        <ProfileSidebar isOpen={isProfileOpen} closeSidebar={() => setIsProfileOpen(false)} user={user} handleLogout={handleLogout} openCart={openCart}/>

        <div className={`cart-sidebar ${isCartOpen ? 'active' : ''}`} style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="cart-header" style={{ background: '#000', color: '#fff', borderBottom: 'none', flexShrink: 0 }}>
                <h3 style={{ color: '#fff', margin: 0 }}>Your Cart ({cart.reduce((a,c) => a + c.qty, 0)})</h3>
                <i className="fa-solid fa-xmark" onClick={() => setIsCartOpen(false)} style={{ color: '#fff', cursor: 'pointer' }}></i>
            </div>
            
            <div className="cart-content" style={{ flex: 1, overflowY: 'auto', padding: '15px' }}>
    {cart.length === 0 ? (
        <div style={{ textAlign: 'center', marginTop: '200px' }}>
            <p>Your cart is empty.</p>
            <button 
                onClick={() => { 
                    setIsCartOpen(false);
                    navigate('/shop');
                }} 
                style={{
                    marginTop: '20px',
                    padding: '12px 30px',
                    backgroundColor: '#000',
                    color: '#fff',
                    border: 'none',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    borderRadius: '4px'
                }}
            >
            Continue Shopping 
            </button>
        </div>
    ) : (
        cart.map((item) => (
            <div key={item.id} className="cart-item">
                <div style={{width:'80px', height:'100px', overflow:'hidden', borderRadius:'4px'}}>
                    <img src={getOriginalImageUrl(item.image)} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="" />
                </div>
                <div style={{flex:1, paddingLeft:'15px'}}>
                    <h4 style={{fontSize:'0.9rem', margin:'0 0 5px 0', textTransform:'uppercase'}}>{item.productName}</h4>
                    <p style={{fontSize:'0.8rem', color:'#666', margin:'0 0 5px 0'}}>Size: <b>{item.size}</b></p>
                    <p style={{fontSize:'0.9rem', fontWeight:'bold', margin:'0 0 10px 0'}}>Rs. {item.price * item.qty}</p>
                    <div className="qty-control">
                        <button onClick={() => updateQuantity(item.id, -1, item.qty)}> − </button>
                        <span>{item.qty}</span>
                        <button onClick={() => updateQuantity(item.id, 1, item.qty)}> + </button>
                    </div>
                </div>
                <i className="fa-solid fa-trash" style={{cursor:'pointer', color:'#999', fontSize:'1rem'}} onClick={() => removeFromCart(item.id)}></i>
            </div>
        ))
    )}
    </div>
            
            {cart.length > 0 && (
            <div style={{ padding:'20px', borderTop:'1px solid #eee', background:'#fff', flexShrink: 0, boxShadow: '0 -4px 10px rgba(0,0,0,0.05)' }}>
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:'15px', fontWeight:'bold', fontSize:'1.1rem'}}>
                    <span>SUBTOTAL:</span>
                    <span>Rs. {cart.reduce((total, item) => total + (item.price * item.qty), 0)}</span>
                </div>
                <button onClick={goToCheckout} style={{width:'100%', padding:'15px', background:'black', color:'white', border:'none', fontWeight:'bold', cursor:'pointer', letterSpacing:'1px', borderRadius: '4px'}}>CHECKOUT NOW</button>
            </div>
            )}
        </div>
        
        <div className={`sidebar ${isSidebarOpen ? 'active' : ''}`}>
            
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                
                <div className="sidebar-header">
                    <h3>Menu</h3>
                    <i className="fa-solid fa-xmark" onClick={() => setIsSidebarOpen(false)}></i>
                </div>
                
                <ul className="sidebar-links" style={{ flex: 1, overflowY: 'auto' }}>
                    
                {user && <li><Link to="#" onClick={() => { setIsSidebarOpen(false); setIsProfileOpen(true); }} style={{fontWeight:'bold'}}><i className="fa-regular fa-user" style={{marginRight: '10px', fontSize: '1.1rem'}}></i>MY PROFILE</Link></li>}
                
                <li className="mobile-dropdown-container">
                    <div className="mobile-menu-item" onClick={() => setIsMobileTopwearOpen(!isMobileTopwearOpen)}>
                        <span>TOPWEAR</span>
                        <i className={`fa-solid ${isMobileTopwearOpen ? 'fa-minus' : 'fa-plus'}`}></i>
                    </div>
                    <ul className={`mobile-submenu ${isMobileTopwearOpen ? 'open' : ''}`}>
                        <li><Link to="/category/tshirt" onClick={closeAllMenus} style={{fontWeight: 'normal'}}>T-Shirts</Link></li>
                        <li><Link to="/category/shirt" onClick={closeAllMenus} style={{fontWeight: 'normal'}}>Shirts</Link></li>
                        <li><Link to="/category/Polo-Tshirt" onClick={closeAllMenus} style={{fontWeight: 'normal'}}>Polo-Tshirt</Link></li>
                    </ul>
                </li>

                <li className="mobile-dropdown-container">
                    <div className="mobile-menu-item" onClick={() => setIsMobileBottomwearOpen(!isMobileBottomwearOpen)}>
                        <span>BOTTOMWEAR</span>
                        <i className={`fa-solid ${isMobileBottomwearOpen ? 'fa-minus' : 'fa-plus'}`}></i>
                    </div>
                    <ul className={`mobile-submenu ${isMobileBottomwearOpen ? 'open' : ''}`}>
                        <li><Link to="/category/jeans" onClick={closeAllMenus} style={{fontWeight: 'normal'}}>Jeans</Link></li>
                        <li><Link to="/category/lower" onClick={closeAllMenus} style={{fontWeight: 'normal'}}>Lowers</Link></li>
                    </ul>
                </li>

                {!user && <li><Link to="/login" onClick={closeAllMenus}><i className="fa-regular fa-user" style={{marginRight: '10px', fontSize: '1.1rem'}}></i>LOGIN</Link></li>}
                </ul>
    <div className="whatsapp-fixed-bottom">
                <div style={{ padding: '20px', borderTop: '1px solid #eaeaea', marginTop: 'auto', backgroundColor: '#fafafa' }}>
                    <a 
                        href="https://wa.me/919310683989?text=Hi%20Antarvaani" 
                        target="_blank" 
                        rel="noreferrer"
                        style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '12px', 
                    textDecoration: 'none', 
                    color: '#000'
                }}
                    >
                        <div style={{ background: '#25D366', color: '#fff', width: '35px', height: '35px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1.2rem' }}>
                    <i className="fa-brands fa-whatsapp"></i>
                </div>
                        <span style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Need Help? Chat with us</span>
                    </a>
                    </div>
                </div>

            </div>
        </div>

        <div className="main" onClick={closeAllMenus}>
            <Routes>
            <Route path="/" element={<Home addToCart={addToCart} showToast={showToast} />} />
            <Route path="/shop" element={<ShopPage addToCart={addToCart} showToast={showToast} />} />
            <Route path="/search" element={isAdmin ? <AdminPage showToast={showToast} /> : <Home addToCart={addToCart} showToast={showToast} />} />
            <Route path="/category/:type" element={<CategoryPage addToCart={addToCart} showToast={showToast} />} />
            <Route path="/product/:id" element={<ProductDetails addToCart={addToCart} showToast={showToast} />} />
            <Route path="/login" element={<LoginSignup setUser={setUser} showToast={showToast} />} />
            <Route path="/checkout" element={<Checkout cart={cart} user={user} clearCart={clearCart} showToast={showToast} updateQuantity={updateQuantity} removeFromCart={removeFromCart} />} />
            <Route path="/profile" element={<Profile showToast={showToast} />} />
            <Route path="/admin" element={isAdmin ? <AdminPage showToast={showToast} /> : <Home addToCart={addToCart} showToast={showToast} />} />
            <Route path="/create-admin" element={isAdmin ? <CreateAdmin showToast={showToast} /> : <Home addToCart={addToCart} showToast={showToast} />} />
            
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/shipping" element={<ShippingPolicy />} />
            <Route path="/returns" element={<ReturnExchange />} />
            <Route path="/refund" element={<RefundPolicy />} />
            <Route path="/story" element={<OurStory />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
            </Routes>
        </div>

        {!isAdminRoute && <MarqueeBar />}

        <footer className="hybrid-footer" style={{ backgroundColor: '#ffffff', borderTop: 'none', paddingTop: '0px' }}>
            

            <div className="mobile-footer-top" style={{ backgroundColor: '#ffffff', paddingTop: '15px' }}>
            <img 
                            src={isTransparent ? '/assets/header-icons/ANTARVAANI%20BLACK%20SVG.svg' : '/assets/header-icons/ANTARVAANI%20BLACK%20SVG.svg'} 
                            alt="ANTARVAANI" 
                        
                        />
            </div>
            
            <div className="footer-main-container" style={{ backgroundColor: '#ffffff', paddingTop: '15px' }}>
                <div className="desktop-brand-section" style={{ backgroundColor: '#ffffff' }}>
                    <img 
                            src={isTransparent ? '/assets/header-icons/ANTARVAANI%20BLACK%20SVG.svg' : '/assets/header-icons/ANTARVAANI%20BLACK%20SVG.svg'} 
                            alt="ANTARVAANI" 
                        
                        />
                    <p className="desktop-copyright-text">© 2026 ANTARVAANI ALL RIGHTS RESERVED.</p>
                </div>
                <div className="footer-links-area" style={{ backgroundColor: '#ffffff' }}>
                    <div className="footer-column" style={{ backgroundColor: '#ffffff' }}>
                        <div className="column-header" onClick={() => toggleFooter('privacy')}>
                            <span> POLICIES & TERMS</span>
                            <i className={`fa-solid ${openFooterSection === 'privacy' ? 'fa-minus' : 'fa-plus'} mobile-arrow`}></i>
                        </div>
                        <ul className={`link-list ${openFooterSection === 'privacy' ? 'show' : ''}`} style={{ backgroundColor: '#ffffff' }}>
                            <li><Link to="/privacy">Privacy Policy</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/terms">Terms & Conditions</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column" style={{ backgroundColor: '#ffffff' }}>
                        <div className="column-header" onClick={() => toggleFooter('shipping')}>
                            <span>SHIPPING POLICY</span>
                            <i className={`fa-solid ${openFooterSection === 'shipping' ? 'fa-minus' : 'fa-plus'} mobile-arrow`}></i>
                        </div>
                        <ul className={`link-list ${openFooterSection === 'shipping' ? 'show' : ''}`} style={{ backgroundColor: '#ffffff' }}>
                            <li><Link to="/shipping">Shipping Policy</Link></li>
                            <li><Link to="/returns">Returns & Exchanges</Link></li>
                            <li><Link to="/refund">Refund Policy</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column" style={{ backgroundColor: '#ffffff' }}>
                        <div className="column-header" onClick={() => toggleFooter('story')}>
                            <span>OUR STORY</span>
                            <i className={`fa-solid ${openFooterSection === 'story' ? 'fa-minus' : 'fa-plus'} mobile-arrow`}></i>
                        </div>
                        <ul className={`link-list ${openFooterSection === 'story' ? 'show' : ''}`} style={{ backgroundColor: '#ffffff' }}>
                            <li><Link to="/story">Our Story</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column" style={{ backgroundColor: '#ffffff' }}>
                        <div className="column-header" onClick={() => toggleFooter('contact')}>
                            <span>CONTACT US</span>
                            <i className={`fa-solid ${openFooterSection === 'contact' ? 'fa-minus' : 'fa-plus'} mobile-arrow`}></i>
                        </div>
                        <ul className={`link-list ${openFooterSection === 'contact' ? 'show' : ''}`} style={{ backgroundColor: '#ffffff' }}>
                            <li><Link to="/contact">Contact Us</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="mobile-social-links" style={{ backgroundColor: '#ffffff' }}>
                <a href="https://www.instagram.com/antarvaani.in?igsh=MXNrMXhkNzJscGt5ag==" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a>
                <a href="https://youtube.com/@antarvaani_com?si=MtinmX6nk2EUwYHE" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube"></i></a>
                <a href="https://www.facebook.com/share/1D81SJjfW6/" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook"></i></a>
            </div>
            <div className="desktop-bottom-bar" style={{ backgroundColor: '#ffffff' }}>
                <div className="connect-label">CONNECT</div>
                <div className="social-text-links" style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
                    <a href="https://www.instagram.com/antarvaani.in?igsh=MXNrMXhkNzJscGt5ag==" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: 'inherit', fontWeight: 'bold', fontSize: '0.9rem' }}><i className="fa-brands fa-instagram" style={{ fontSize: '1.2rem' }}></i> INSTAGRAM</a>
                    <a href="https://youtube.com/@antarvaani_com?si=MtinmX6nk2EUwYHE" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: 'inherit', fontWeight: 'bold', fontSize: '0.9rem' }}><i className="fa-brands fa-youtube" style={{ fontSize: '1.2rem' }}></i> YOUTUBE</a>
                    <a href="https://www.facebook.com/share/1D81SJjfW6/" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: 'inherit', fontWeight: 'bold', fontSize: '0.9rem' }}><i className="fa-brands fa-facebook" style={{ fontSize: '1.2rem' }}></i> FACEBOOK</a>
                </div>
            </div>
            <div className="mobile-bottom-bar" style={{ backgroundColor: '#ffffff' }}><p>© 2026 ANTARVAANI  ALL RIGHTS RESERVED.</p></div>
        </footer>
        </div>
    );
    }

    function App() { return <MainContent />; }
    export default App;